import { FormField, FormHelp, Input, Label } from '@zillow/constellation-10';

type Props = {
  onChange: (value: string) => void;
  value: string;
  disabled?: boolean;
  fieldLabel: string;
  formHelpText?: string;
  required?: boolean;
  onBlur: (fieldName: string, value: string | number) => void;
  fieldName: string;
  errorMessage?: string;
  charLimit?: number;
};
const FeeInputField = ({
  onChange,
  value = '',
  required = false,
  disabled = false,
  fieldLabel,
  formHelpText = '',
  onBlur = () => {},
  fieldName,
  errorMessage,
  charLimit,
}: Props) => {
  return (
    <FormField
      description={<FormHelp error={Boolean(errorMessage)}>{errorMessage || formHelpText}</FormHelp>}
      required={required}
      label={<Label optional={!required}>{fieldLabel}</Label>}
    >
      <Input
        disabled={disabled}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
          onBlur(fieldName, Number(e.target.value));
        }}
        maxLength={charLimit}
      />
    </FormField>
  );
};

export default FeeInputField;
